module.exports = __webpack_public_path__ + "img/japan-mobility-logo.fd9d50ef.png";